import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { AssignableKeys } from './types'

export const messageLookups: Record<AssignableKeys, JSX.Element> = {
  amount: <FormattedMessage id="amount" />,
  reference: <FormattedMessage id="reference" />,
  createdAt: <FormattedMessage id="createdAt" />,
  dueAt: <FormattedMessage id="dueAt" />,

  payerEmail: <FormattedMessage id="customerEmail" />,
  payerAddress: <FormattedMessage id="customerAddress" />,
  payerTaxNumber: <FormattedMessage id="taxNumber" />,
  payerPhonenumber: <FormattedMessage id="customerPhonenumber" />,
  payerName: <FormattedMessage id="customerName" />,

  discountName: <FormattedMessage id="discountName" />,
  discountRate: <FormattedMessage id="discountRate" />,

  taxName: <FormattedMessage id="taxName" />,
  taxRate: <FormattedMessage id="taxRate" />,

  organization: <FormattedMessage id="organization" />,
  email: <FormattedMessage id="email" />,
}
